enum BenchmarkingLineOfBusinessEnum {
  Medicare = 1,
  Marketplace = 2,
  Medicaid = 3,
}

export { BenchmarkingLineOfBusinessEnum };
